import { Project } from '@slices/projects';

import { STORAGE_KEYS } from '@config/storage';

import { ensureIsRememberedLogin } from '@storage/auth';

export const readProjectsData = (): {
  projects: Project[] | undefined;
} => {
  const isRememberedLogin = ensureIsRememberedLogin();

  let rawProjectsData;
  let projectsData;

  if (isRememberedLogin) {
    rawProjectsData = localStorage.getItem(STORAGE_KEYS.PROJECTS);
  } else {
    rawProjectsData = sessionStorage.getItem(STORAGE_KEYS.PROJECTS);
  }

  try {
    projectsData = JSON.parse(rawProjectsData ?? '');
  } catch (error) {
    projectsData = { projects: undefined };
  }

  return projectsData;
};

export const readProjectsSelectedProjectId = (): undefined | string => {
  const isRememberedLogin = ensureIsRememberedLogin();

  let rawProjectsData;
  let projectsData;

  if (isRememberedLogin) {
    rawProjectsData = localStorage.getItem(STORAGE_KEYS.SELECTED_PROJECT_ID);
  } else {
    rawProjectsData = sessionStorage.getItem(STORAGE_KEYS.SELECTED_PROJECT_ID);
  }

  try {
    projectsData = JSON.parse(rawProjectsData ?? '');
  } catch (error) {
    projectsData = undefined;
  }

  return projectsData;
};

export const writeProjectsSelectedProjectId = (
  selectedProjectId: string
): void => {
  const isRememberedLogin = ensureIsRememberedLogin();

  const processedProjectsData = JSON.stringify(selectedProjectId);

  if (isRememberedLogin) {
    localStorage.setItem(
      STORAGE_KEYS.SELECTED_PROJECT_ID,
      processedProjectsData
    );
  } else {
    sessionStorage.setItem(
      STORAGE_KEYS.SELECTED_PROJECT_ID,
      processedProjectsData
    );
  }
};

export const writeProjectsData = (projects: Project[]): void => {
  const isRememberedLogin = ensureIsRememberedLogin();

  const processedProjectsData = JSON.stringify({
    projects,
  });

  if (isRememberedLogin) {
    localStorage.setItem(STORAGE_KEYS.PROJECTS, processedProjectsData);
  } else {
    sessionStorage.setItem(STORAGE_KEYS.PROJECTS, processedProjectsData);
  }
};

export const removeProjectsData = (): void => {
  const isRememberedLogin = ensureIsRememberedLogin();

  if (isRememberedLogin) {
    localStorage.removeItem(STORAGE_KEYS.PROJECTS);
    localStorage.removeItem(STORAGE_KEYS.SELECTED_PROJECT_ID);
  } else {
    sessionStorage.removeItem(STORAGE_KEYS.PROJECTS);
    sessionStorage.removeItem(STORAGE_KEYS.SELECTED_PROJECT_ID);
  }
};
